import { NavigationStore } from '../../store/navigation-store';
export class NavigationHandlers {
    static initCloseButtons() {
        const closeButtons = document.querySelectorAll('.header-cart-close-btn');
        closeButtons.forEach((btn) => {
            btn.addEventListener('click', () => {
                NavigationStore.getState().closeAll();
            });
        });
    }
}
